import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthConfig,
  ConfigModule,
  FeaturesConfig,
  I18nConfig,
  OccConfig,
  provideConfig,
  SiteContextConfig,
} from '@spartacus/core';
import {
  LayoutConfig,
  SkipLinkConfig,
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from '../../environments/environment';
import { customGlobalMessageConfig } from '../SGRE-config/message-config';
import { customLayoutConfig } from '../SGRE-config/layout-config';

@NgModule({
  declarations: [],
  imports: [
    // `/homepage` is rendered as a normal CMS page; routing to login is
    // handled directly via MSAL by the custom CustomRouteGuard.
    ConfigModule.withConfig(customGlobalMessageConfig),
  ],
  providers: [
    /** Below provided is the custom-layoutConfig that is used in this application */
    provideConfig(<LayoutConfig>{
      layoutSlots: customLayoutConfig.layoutSlots,
    }),
    provideConfig(<SkipLinkConfig>{
      skipLinks: [],
    }),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: environment.siteUrls.getBaseUrl,
          prefix: environment.siteUrls.getPrefix,
        },
      },
    }),

    provideConfig(<AuthConfig>{
      authentication: {
        customLoginPage: undefined, // Prevents route conflicts between spartacus login page and MSAL guard
        client_id: environment.oAuthConfigDetails.client_id,
        client_secret: environment.oAuthConfigDetails.client_secret,
      },
    }),
    provideConfig({
      features: {
        userCmsEndpoints: true,
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {
        language: ['en', 'de', 'es'],
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        backend: {
          loadPath: 'i18n/{{lng}}.json',
        },
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '2211.27',
      },
    }),
  ],
})
export class SpartacusConfigurationModule {}
